export default "__VITE_ASSET__CKCLuAgC__"